import { SuppliesPaymentTerms } from "@redotech/redo-fulfillment-common/supplies";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSelectDropdown } from "@redotech/redo-web/select-dropdown";
import { FormSwitch } from "@redotech/redo-web/switch";
import { input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const suppliesEnabledInput = input<boolean>();
export const suppliesEnabledDefault = false;

// Undefined = immediate (charge the chosen method at checkout).
export const paymentTermsInput = input<SuppliesPaymentTerms | undefined>();
export const paymentTermsDefault = undefined;

const PAYMENT_TERMS_LABEL: Record<SuppliesPaymentTerms, string> = {
  [SuppliesPaymentTerms.Net15]: "Net 15",
  [SuppliesPaymentTerms.Net30]: "Net 30",
};

export const SuppliesSettingsCard = memo(function SuppliesSettingsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  return (
    <Card title="Supplies Settings" w="full">
      <Flex dir="column" gap="md">
        <FormSwitch
          input={input.inputs.suppliesEnabled}
          label="Supplies Enabled"
        />
        <FormSelectDropdown
          input={input.inputs.paymentTerms}
          label="Payment terms"
          options={[
            undefined,
            SuppliesPaymentTerms.Net15,
            SuppliesPaymentTerms.Net30,
          ]}
        >
          {(option) => (option ? PAYMENT_TERMS_LABEL[option] : "Immediate")}
        </FormSelectDropdown>
      </Flex>
    </Card>
  );
});
